var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.5039 19.5C19.7468 14.6202 22.662 11.7131 27 11.3324V8.63297C22.662 8.25228 19.7468 5.37978 19.5039 0.5L16.2763 1.19217C16.4499 2.95719 17.0745 4.51457 18.1157 5.93352C19.1915 7.31785 20.4062 8.21767 21.7943 8.63297H0V11.3324H21.7943C20.4062 11.7477 19.1915 12.6475 18.1157 14.0665C17.0745 15.4854 16.4499 17.0428 16.2763 18.7732L19.5039 19.5Z","fill":"#FFD747"}));
}

Arrow.defaultProps = {"width":"27","height":"20","viewBox":"0 0 27 20","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
